export default {
    parse(queryString) {
        if (!queryString) {
            queryString = location.search;
        }
        const data = {};
        if (queryString.substring(0, 1) === '?') {
            queryString = queryString.substring(1);
        }
        let args = queryString.split('&');
        for (let arg of args) {
            const parts = arg.split('=');
            const key = parts[0];
            // Don't lose part of value if it has an equal in it
            const val = parts.slice(1).join('=');
            data[key] = val;
        }
        return data;
    },

    pathSegment(index) {
        const parts = location.pathname.split(/\//g).filter((s) => s);
        if (index >= 0) {
            return parts[index];
        } else {
            return parts[parts.length + index];
        }
    },
};
